export const NAME = 'Chat';
export const SUBSCRIPTION_TTL = 20_000;
export const PRIVATE = '__UNIQUE_OR_PRIVATE__';
